import { inject, Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { BehaviorSubject, Observable, of, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { User } from "../models/user";
import { environment } from "@env/environment";
import { GlobalApiService } from "@core/http/global-api.service";
import { AuthUser } from "@core/models/auth/auth-user";
import { clearAllBreadCrumb } from "@theme/breadCrum-store/breadcrum.action";
import { Store } from "@ngxs/store";
import { IImageLoginToken } from "app/authentication/models/image-login-token.interface";
import { ClearPhysicianUserIdAction } from "app/authentication/Store/auth.action";
import { UserObj } from "app/crmc-validate/crmc-validate.component";
import { StateClear } from "ngxs-reset-plugin";
import * as CryptoJS from 'crypto-js';
import { MatDialog } from "@angular/material/dialog";


export class LoginModel {
  userId: string;
  password: string;
  loginSystemIP: string;
  userName?:string
}

@Injectable({
  providedIn: "root",
})
export class AuthService {
  
  private iv = CryptoJS.enc.Utf8.parse('\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0'); // 16-byte IV (all zeros)
  private currentUserSubject: BehaviorSubject<AuthUser>;
  public currentUser: Observable<AuthUser>;

  private _dialog = inject(MatDialog);

  constructor(private http: HttpClient,private apiService:GlobalApiService, private store:Store) {
    this.currentUserSubject = new BehaviorSubject<AuthUser>(
      JSON.parse(localStorage.getItem("currentUser"))
    );
    this.userLoggedIn.next(false);
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): AuthUser {
    return this.currentUserSubject.value;
  }
  private userLoggedIn = new Subject<boolean>();
  getUserLoggedIn(): Observable<boolean> {
    return this.userLoggedIn.asObservable();
  }
  setUserLoggedIn(userLoggedIn: boolean) {
    this.userLoggedIn.next(userLoggedIn);
  }

  login(username: string, password: string,clientIpAddress,twofactorauthentication:boolean) {
    //return this.apiService.getData(environment.authenticate+"?userId="+username+'&password='+password)
    // return this.apiService.getData(`${environment.authenticate}?userId=${username}&password=${password}`)
    //let body='{userName:${}}'
    let body={'userId':username,'password':password,'LoginIPAddress':clientIpAddress,'TwoFactorAuthentication':twofactorauthentication};
    // console.log(JSON.stringify(body));
    // return this.apiService.getData(`${environment.authenticate}?userId=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`)
    return this.apiService.postData(`${environment.authenticate}`,body)
   /* return this.http
      .post<any>(`${environment.apiUrl}/authenticate`, {
        username,
        password,
      })*/
      .pipe(
        map((user) => {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          if(!twofactorauthentication){
          localStorage.setItem("currentUser", JSON.stringify(user.body));
          this.currentUserSubject.next(user.body);
          }
          return user;
          
        })
      );
  }
  directMessegeLogin(username: string, password: string,clientIpAddress,twofactorauthentication:boolean) {
    let body={'userId':username,'password':password,'LoginIPAddress':clientIpAddress,'TwoFactorAuthentication':twofactorauthentication};
    return this.apiService.postData(`${environment.DirectMessegeLoginauthenticate}`,body)
  }
  //SR1
  generateOtpByCellNumber(cellNumber:number,body):Observable<HttpResponse<any>>{
    return this.apiService.postData(`${environment.generateOtpByCellNumber}?cellnumber=`+cellNumber,body)
  }
  loginByCellNumber(otp:string,cellNumber:string):Observable<HttpResponse<any>>{
    return this.apiService.getData(`${environment.loginByCellNumber}?Otp=`+otp+`&ReceivedContact=`+cellNumber).pipe(
      map((user) => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        if(user.body?.value!=='Invalid OTP'){
        localStorage.setItem("currentUser", JSON.stringify(user.body));
        this.currentUserSubject.next(user.body);
        }
        return user;
      })
    );
  }
  //SR1

  /**
   * image DB login service.
   * @param imageLogin image login data `LoginModel`.
   * @service `Login/Login`.
   * @returns `Observable<HttpResponse<IImageLoginToken>>`.
   */
  imageLogin(imageLogin: LoginModel): Observable<HttpResponse<IImageLoginToken>> {
    let body = JSON.stringify(imageLogin);
    return this.apiService.postImageBaseUrl(environment.imageLogin, body);
  }
  aiLogin(aiLogin: any): Observable<HttpResponse<any>> {
    let body = JSON.stringify(aiLogin);
    // console.log(body)lk
    return this.apiService.postClinoteLoginData(environment.aiLogin, body);
  }
storeCurrentUser(value){
  this.currentUserSubject.next(value)
}
getMasterData(userId: number){
  return this.apiService.getData(`${environment.masterData}?userId=`+userId);
}
  logout() {
    // remove user from local storage to log user out
    // localStorage.removeItem("currentUser");
    localStorage.clear();
    // this.store.dispatch(new clearAllBreadCrumb());
    // this.store.dispatch(new ClearPhysicianUserIdAction());
    this.store.dispatch(new StateClear()); // To clear all states.
    this.setUserLoggedIn(false);
    this.currentUserSubject.next(null);
    this._dialog.closeAll();
    return of({ success: false });
  }
  forGotPassword(userName,loginForm,patientType):Observable<HttpResponse<any>>{
    return this.apiService.getData(environment.forGotPassword+'?userId='+userName+'&loginForm='+loginForm+'&patientType='+patientType)
  }


  postCRMCValidate(body:UserObj):Observable<HttpResponse<any>>{
    return this.apiService.postData(environment.crmcValidate, body).pipe(
      map((user) => {
        localStorage.setItem("currentUser", JSON.stringify(user.body));
        this.currentUserSubject.next(user.body);
        return user;
      })
    );
  }


  encrypt(plainText: string): string {
    const aesKey = this.getSHA256Key(environment.secretKey); // Generate key using SHA-256
    const encrypted = CryptoJS.AES.encrypt(plainText, aesKey, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString(); // Return Base64 encrypted string
  }

  // AES Decryption
  decrypt(encryptedText: string): string {
    const aesKey = this.getSHA256Key(environment.secretKey); // Generate key using SHA-256
    const decrypted = CryptoJS.AES.decrypt(encryptedText, aesKey, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8); // Return decrypted string
  }
  generateSHA256Hash(input: string,key :any,iv:any): string {
    return CryptoJS.AES.encrypt(input, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
  }
   // Generate SHA-256 key
   private getSHA256Key(key: string): CryptoJS.lib.WordArray {
    return CryptoJS.SHA256(key);
  }
}
